import React from 'react';
import _ from 'lodash';
import { Input } from 'reactstrap';

export const formatArrayData = (value) => {
    const dataOptions = [];
    for (var i = 0; i < value.length; i++) {
        dataOptions.push({
            value: value[i],
            label:
                new Date(value[i].data + 'T00:00:00').toLocaleDateString('pt-BR') +
                ' - PV ' +
                Number(value[i].numPer ? value[i].numPer : 0) +
                '/' +
                value[i].anoPer,
        });
    }
    return dataOptions;
};

export const gerarStringFiltro = ({ planejamentoFilter, capacidadeFilterSelected, recursosCriticosFilterSelected }) => {
    let filtro = {};

    for (let x in planejamentoFilter) {
        if (x === 'valueMaterial') {
            if (planejamentoFilter.valueMaterial && planejamentoFilter.valueMaterial.length > 0) {
                filtro.material = _setFiltroValue(planejamentoFilter.valueMaterial);
            }
        } else if (x === 'valueJustificativa') {
            if (planejamentoFilter.valueJustificativa && planejamentoFilter.valueJustificativa.length) {
                filtro.justificativa = _setFiltroValue(planejamentoFilter.valueJustificativa);
            }
        } else if (x === 'valueNotMaterial') {
            if (planejamentoFilter.valueNotMaterial && planejamentoFilter.valueNotMaterial.length > 0) {
                filtro.notMaterial = _setFiltroValue(planejamentoFilter.valueNotMaterial);
            }
        } else if (x === 'valueNotObservacao') {
            if (planejamentoFilter.valueNotObservacao && planejamentoFilter.valueNotObservacao.length > 0) {
                filtro.notObservacao = _setFiltroValue(planejamentoFilter.valueNotObservacao);
            }
        } else if (x === 'valueNotCtZcos') {
            if (planejamentoFilter.valueNotCtZcos && planejamentoFilter.valueNotCtZcos.length > 0) {
                filtro.notCtZcos = _setFiltroValue(planejamentoFilter.valueNotCtZcos);
            }
        } else if (x === 'valueNo' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.no = planejamentoFilter[x].map((x) => x.value);
        } else if (x === 'valueNotNo' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.notNo = planejamentoFilter[x].map((x) => x.value);
        } else if (x === 'valueFabricaPreparacao' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.fabricaPreparacao = planejamentoFilter[x].map((x) => x.value);
        } else if (x === 'valueFabricaVersaoPreparacao' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.fabricaVersaoPreparacao = planejamentoFilter[x].map((x) => x.value);
        } else if (x === 'valueQtdProgramadaManual' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.programacaoManual = planejamentoFilter[x].map((x) => x.value);
        } else if (x === 'valueTipoProdutoAcabado' && planejamentoFilter[x] && planejamentoFilter[x].value) {
            filtro.tipoProdutoAcabado = planejamentoFilter[x].value;
        } else if (x === 'valueFabrica' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.fabrica = planejamentoFilter[x].map((x) => x.value);
        } else if (x === 'valueFabricaVersao' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.fabricaVersao = planejamentoFilter[x].map((x) => x.value);
        } else if (x === 'valueColecao' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.colecao = planejamentoFilter[x].map((x) => x.value);
        } else if (x === 'valueObservacao' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.observacao = planejamentoFilter[x].map((x) => x.value);
        } else if (x === 'valueNivelRisco' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.nivelRisco = planejamentoFilter[x].map((x) => x.value);
        } else if (x === 'valueNaoPrograma' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.naoPrograma = planejamentoFilter[x].value;
        } else if (x === 'valueAplicouMI' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.aplicouMI = planejamentoFilter[x].value;
        } else if (x === 'valueFaixaOperacional' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.faixaOperacional = _setFiltroValue(planejamentoFilter.valueFaixaOperacional);
        } else if (x === 'valueNotFaixaOperacional' && !_.isEmpty(planejamentoFilter[x])) {
            filtro.notFaixaOperacional = _setFiltroValue(planejamentoFilter.valueNotFaixaOperacional);
        } else if (x === 'valueLicenca') {
            if (planejamentoFilter.valueLicenca && planejamentoFilter.valueLicenca.length > 0) {
                filtro.licenca = _setFiltroValue(planejamentoFilter.valueLicenca);
            }
        } else if (x === 'valueCliente') {
            if (planejamentoFilter.valueCliente && planejamentoFilter.valueCliente.length > 0) {
                filtro.cliente = _setFiltroValue(planejamentoFilter.valueCliente);
            }
        } else if (x === 'valueClienteEspecial') {
            if (planejamentoFilter.valueClienteEspecial) {
                filtro.clienteEspecial = planejamentoFilter.valueClienteEspecial.value;
            }
        } else if (x === 'valueGrupoDeProduto') {
            if (planejamentoFilter.valueGrupoDeProduto && planejamentoFilter.valueGrupoDeProduto.length > 0) {
                filtro.grupoDeProduto = _setFiltroValue(planejamentoFilter.valueGrupoDeProduto);
            }
        } else if (x === 'valueCtZcos') {
            if (planejamentoFilter.valueCtZcos && planejamentoFilter.valueCtZcos.length > 0) {
                filtro.ctZcos = _setFiltroValue(planejamentoFilter.valueCtZcos);
            }
        } else if (Array.isArray(planejamentoFilter[x])) {
            planejamentoFilter[x].forEach((item) => {
                filtro.caracteristicas = _setFiltroCaracteristicas(filtro.caracteristicas, item);
            });
        }

        // else if (x === 'valueSaldoNegativo' && !_.isEmpty(planejamentoFilter[x])) {
        //     if (!_.isEmpty(planejamentoFilter[x])) {
        //         filtro.deAte = _setFiltroDeAte(filtro.deAte, x.charAt(5).toLowerCase() + x.slice(6), planejamentoFilter[x], true);
        //     }
        // }
        else if (x === 'valueRA' && !_.isEmpty(planejamentoFilter[x])) {
            if (!_.isEmpty(planejamentoFilter[x])) {
                filtro.deAte = _setFiltroDeAte(filtro.deAte, 'qtdSegundaQualidade', planejamentoFilter[x]);
            }
        } else {
            if (!_.isEmpty(planejamentoFilter[x])) {
                filtro.deAte = _setFiltroDeAte(filtro.deAte, x.charAt(5).toLowerCase() + x.slice(6), planejamentoFilter[x]);
            }
        }
    }

    if (capacidadeFilterSelected && capacidadeFilterSelected.length > 0) {
        filtro.capacidades = capacidadeFilterSelected.map((e) => {
            const parts = e.split('-');
            return {
                fabrica: parts[0],
                no: parts[1],
            };
        });
    }

    if (recursosCriticosFilterSelected && recursosCriticosFilterSelected.length > 0) {
        let recursosCriticos = [];
        for (let i = 0; i < recursosCriticosFilterSelected.length; i++) {
            const recursoCriticoSelected = recursosCriticosFilterSelected[i];
            if (recursoCriticoSelected.centroTrab.length === 0 && recursoCriticoSelected.chaveMod.length === 0) {
                recursosCriticos.push({
                    tipoMaterial: recursoCriticoSelected.tipoMaterial,
                });
                continue;
            }

            recursosCriticos = recursosCriticos.concat(
                recursoCriticoSelected.centroTrab.map((x) => ({
                    tipoMaterial: recursoCriticoSelected.tipoMaterial,
                    centroTrabChaveMod: x.value,
                })),
                recursoCriticoSelected.chaveMod.map((x) => ({
                    tipoMaterial: recursoCriticoSelected.tipoMaterial,
                    centroTrabChaveMod: x.value,
                }))
            );
        }
        filtro.recursosCriticos = recursosCriticos;
    }

    return JSON.stringify(filtro);
};

export const _setFiltroValue = (value) => {
    return value.map((x) => x.value);
};

export const _setFiltroDeAte = (arr, name, value, negativo = false) => {
    let newArr = Object.assign(arr || []);
    if (negativo)
        newArr.push({
            campo: name,
            de: value.ate * -1,
            ate: value.de * -1,
        });
    else newArr.push({ campo: name, de: !value.de ? null : Number(value.de), ate: !value.ate ? null : Number(value.ate) });
    return newArr;
};

export const _setFiltroCaracteristicas = (array, value) => {
    let newArr = Object.assign(array || []);
    let itemAdded = false;

    newArr.forEach((item) => {
        if (item.id === value.caracteristicaId) {
            if (item.values) item.values.push(value.value);
            else item.values = [value.value];

            itemAdded = true;
        }
    });

    if (!itemAdded) {
        newArr.push({ id: value.caracteristicaId, values: [value.value] });
    }

    return newArr;
};

export const mountFilter = (array) => {
    return array
        .filter((item) => item)
        .map((item) => ({
            value: item,
            label: item,
        }));
};

const sum = (data, column) =>
    Math.trunc(
        data
            .slice(2)
            .map((v) => v[column.dataKey])
            .filter((v) => v)
            .reduce((a, b) => a + parseFloat(b), 0)
    );

const percCoberturaEstoqueCalc = (data) => {
    const materiais = data.slice(2);
    let vendaPrevTotal = 0;
    let saldoCob = 0;

    materiais.forEach((x) => {
        vendaPrevTotal += x.qtdPrevisaoTotal > x.qtdVendaTotal ? x.qtdPrevisaoTotal : x.qtdVendaTotal;
        saldoCob += x.saldoCobertura;
    });

    return (saldoCob / vendaPrevTotal) * 100;
};

export const ColumnConfig = [
    {
        label: '',
        width: 25,
        dataKey: 'checkbox',
        cell: (i, editavel, checked, onChange) => {
            return (
                <Input
                    type='checkbox'
                    id={'checkbox' + i}
                    name={'checkbox' + i}
                    checked={editavel ? checked : false}
                    onChange={onChange}
                    readOnly={!editavel}
                    disabled={!editavel}
                    style={{
                        marginTop: 0,
                        marginLeft: 0,
                        cursor: editavel ? 'pointer' : 'not-allowed',
                    }}
                />
            );
        },
    },
    {
        width: 30,
        label: 'NP',
        dataKey: 'naoPrograma',
        cell: (i, checked) => {
            return (
                <Input
                    type='checkbox'
                    id={'naoPrograma' + i}
                    name={'naoPrograma' + i}
                    checked={checked}
                    //onChange={onChange}
                    readOnly={true}
                    disabled={false}
                    style={{
                        marginTop: 0,
                        marginLeft: 0,
                    }}
                />
            );
        },
        descricao: 'Marca os materiais que não podem ser programados de acordo com as regras de reposição cadastradas',
    },
    {
        label: 'Justificativa',
        width: 200,
        dataKey: 'justificativaNP',
    },
    {
        label: 'Material',
        width: 90,
        dataKey: 'material',
    },
    {
        label: 'Descrição',
        width: 200,
        dataKey: 'descricao',
    },
    {
        label: 'Espécie',
        width: 200,
        dataKey: 'especie',
    },
    {
        label: 'Espécie\nDet',
        width: 200,
        dataKey: 'especieDetalhada',
    },
    {
        label: 'Est.',
        width: 40,
        dataKey: 'estacao',
    },
    {
        label: 'Col.',
        width: 40,
        dataKey: 'colecao',
    },
    {
        label: 'Marca',
        dataKey: 'marca',
    },
    {
        width: 60,
        label: 'Saldo+',
        dataKey: 'saldoPositivo',
        sum: sum,
        descricao:
            '= (Estoque inicial + WIP+ quantidade de Peças) – (venda realizada ou previsão atual). Somente apresenta resultado se for positivo', //Saldo +
    },
    {
        width: 60,
        label: 'Saldo-',
        dataKey: 'saldoNegativo',
        sum: sum,
        descricao:
            '= (Estoque inicial + WIP + quantidade de Peças) – (venda realizada ou previsão atual). Somente apresenta resultado se for negativo', //Saldo -
    },
    {
        width: 70,
        label: 'Dt.Remessa',
        dataKey: 'data',
    },
    {
        width: 50,
        label: 'P.V',
        dataKey: 'pv',
    },
    {
        width: 64,
        label: 'Lote mín.',
        dataKey: 'loteMinimo',
        descricao: 'Lote mínimo de produção pré-definido pela indústria', //Lote mínimo
    },
    {
        width: 60,
        label: 'Est.Ini.\n(+)',
        dataKey: 'estoqueInicial',
        sum: sum,
        descricao:
            '= (Estoque físico (C) + Estoque em processo (B e F)) – (Vendas passadas + Segunda qualidade), se o resultado for negativo deverá zerar para o usuário', //Estoqu inicial
    },
    {
        width: 60,
        label: 'WIP\n(+)',
        dataKey: 'qtdEstoqueProdPed',
        sum: sum,
        descricao: 'Estoque em processo (B e F) para a data da PV atual', //WIP
    },
    {
        width: 60,
        label: 'Wip Futuro',
        dataKey: 'qtdWipFuturo',
        descricao: 'Wip Futuro', //Wip Futuro
    },
    {
        width: 60,
        label: 'Alt.Man.',
        dataKey: 'alteradoManual',
        cell: (alteradoManual) => {
            return <div>{alteradoManual ? <i className='fa fa-pencil fa-sm' /> : ''}</div>;
        },
        descricao: 'Indicativo de quando é feita qualquer alteração no material a nível do SKU', //Alteracao manual
    },
    {
        width: 90,
        label: 'Qtd.Pçs\nProg. Manual',
        dataKey: 'qtdProgramadaManual',
        sum: sum,
        descricao: 'Quantidade de peças programadas manualmente. Pode extrapolar a venda ou previsão.', //Quantidade de peças
    },
    {
        width: 70,
        label: 'Qtd.Pçs\n SAP',
        dataKey: 'qtdProgramadaSAP',
        sum: sum,
        descricao: 'Quantidade de peças programadas em cada PV (Referência SAP)', //Quantidade de peças
    },
    {
        width: 70,
        label: 'Qtd.Pçs\n(+)',
        dataKey: 'qtdProgramada',
        sum: sum,
        cell: (value, editavel, onChange, onKeyPress, onBlur, onPaste) => {
            if (editavel === true) {
                return (
                    <Input
                        pattern='[0-9]*'
                        onChange={onChange}
                        onKeyPress={onKeyPress}
                        onBlur={onBlur}
                        onPaste={onPaste}
                        type='text'
                        //   id='qtdProgramada'
                        placeholder=''
                        value={value ? value : ''}
                        className='col-sm-12 form-control-sm'
                        autoComplete='off'
                    ></Input>
                );
            } else {
                return value ? value : '';
            }
        },
        descricao: 'Quantidade de peças programadas em cada PV', //Quantidade de peças
    },
    {
        width: 60,
        label: '% Ante.',
        dataKey: 'percAnt',
        cell: (value, editavel, onChange, onKeyPress, onBlur, onPaste) => {
            if (editavel === true) {
                return (
                    <Input
                        pattern='[0-9]*'
                        onChange={onChange}
                        onKeyPress={onKeyPress}
                        onBlur={onBlur}
                        onPaste={onPaste}
                        type='text'
                        //   id='percAnt'
                        placeholder=''
                        value={value ? value : ''}
                        className='col-sm-12 form-control-sm'
                        autoComplete='off'
                    ></Input>
                );
            } else {
                return value ? value : '';
            }
        },
        descricao:
            '% de antecipação onde o usuário pode escolher o valor conforme estratégia de planejamento, ex.: nível de risco: Alto 15%', //Perc.Ant
    },
    {
        width: 90,
        label: '% Ante. Venda Futura',
        dataKey: 'percAntVendaFutura',
        cell: (value, editavel, onChange, onKeyPress, onBlur, onPaste) => {
            if (editavel === true) {
                return (
                    <Input
                        pattern='[0-9]*'
                        onChange={onChange}
                        onKeyPress={onKeyPress}
                        onBlur={onBlur}
                        onPaste={onPaste}
                        type='text'
                        placeholder=''
                        value={value ? value : ''}
                        className='col-sm-12 form-control-sm'
                        autoComplete='off'
                    ></Input>
                );
            } else {
                return value ? value : '';
            }
        },
        descricao:
            '% de antecipação onde o usuário pode escolher o valor conforme estratégia de planejamento considerando a venda futura, ex.: nível de risco: Alto 15%',
    },
    {
        width: 70,
        label: '% Est.Seg.',
        dataKey: 'percEstoqueSeg',
        cell: (value, editavel, onChange, onKeyPress, onBlur, onPaste) => {
            if (editavel === true) {
                return (
                    <Input
                        pattern='[0-9]*'
                        onChange={onChange}
                        onKeyPress={onKeyPress}
                        onBlur={onBlur}
                        onPaste={onPaste}
                        type='text'
                        //    id='percEstoqueSeg'
                        placeholder=''
                        value={value ? value : ''}
                        className='col-sm-12 form-control-sm'
                        autoComplete='off'
                    ></Input>
                );
            } else {
                return value ? value : '';
            }
        },
        descricao: '% correspondente a quanto de cobertura de estoque de segurança o usuário pretende manter', //percEstoqueSeguranca
    },
    {
        width: 70,
        label: 'Fábrica',
        dataKey: 'cdFabrica',
        cell: (value, editavel, onChange, cdFabrica) => {
            if (!editavel) {
                return cdFabrica;
            }

            let filter = value.filter((x) => x.CD_FABRICA);
            let map = filter.map((x) => x.CD_FABRICA);
            let set = Array.from(new Set(map));

            return (
                <Input type='select' name='fabrica' id='fabrica' className='form-control-sm' onChange={onChange} value={cdFabrica}>
                    {value ? (
                        set.map((e, i) => {
                            return (
                                <option key={i} value={e} defaultValue={cdFabrica === e}>
                                    {e}
                                </option>
                            );
                        })
                    ) : (
                        <option></option>
                    )}
                </Input>
            );
        },
        descricao: 'Fábrica de costura escolhida para produção de um material em uma determinada PV', //Fábrica
    },
    {
        label: 'CT/ZCOS',
        width: 80,
        dataKey: 'ctZcos',
    },
    {
        width: 60,
        label: 'Est.Seg.\n(-)',
        dataKey: 'estoqueSeguranca',
        sum: sum,
        descricao: 'Volume de previsão destinada ao estoque de segurança (PE)', //estoqueSeguranca
    },
    {
        width: 60,
        label: 'Falta PE\n(-)',
        dataKey: 'qtdFaltaEstoqueSeguranca',
        sum: sum,
        descricao: 'Quantidade faltante para completar o estoque de PE', //Falta PE
    },
    {
        width: 70,
        label: 'F. Operacional',
        dataKey: 'faixaOperacional',
        descricao: 'Planejamento de Materiais pela Curva de Categoria Operacional', //Faixa Operacional
    },
    {
        width: 80,
        label: 'Saldo descasado',
        dataKey: 'saldoDescasado',
        descricao: 'Saldo descasado nos conjuntos', //Saldo descasado
    },
    {
        width: 60,
        label: 'Programação PE',
        dataKey: 'qtdPecasEstoqueSeguranca',
        sum: sum,
        descricao: 'Quantidade programada para atender a falta de PE', //Programação de PE
    },
    {
        width: 60,
        label: 'Nó',
        dataKey: 'no',
        descricao: 'Característica do processo de costura ou aspecto do material, ex.: C59 destinado a camisa pólo ', //Nó
    },
    {
        width: 80,
        label: 'Qnt.Prog.S.M',
        dataKey: 'qtdProgSemMulti',
    },
    {
        width: 80,
        label: '%.Ante.S.M',
        dataKey: 'percAntSemMulti',
    },
    {
        width: 80,
        label: 'Qnt.Prog.M.I',
        dataKey: 'qtdProgSemIgua',
    },
    {
        width: 80,
        label: '%.Ante.M.i',
        dataKey: 'percAntSemIgua',
    },
    {
        width: 70,
        label: 'Qtd.Alocada',
        dataKey: 'qtdAlocada',
        sum: sum,
        descricao: 'Verifica se houve alocação antecipada (aba D e F transação /AFS/MD04)', //Qnt. Alocada
    },
    {
        width: 70,
        label: 'Venda Descoberta',
        dataKey: 'vendaDescoberta',
        sum: sum,
        descricao: '= (Estoque inicial + WIP) – (venda realizada ou previsão atual). Somente apresenta resultado se for negativo', //Venda Descoberta
    },
    {
        width: 61,
        label: 'Venda R.\n(-)',
        dataKey: 'qtdVenda',
        sum: sum,
        descricao: 'Venda correspondente a cada PV', //Venda Realizada,
    },
    {
        label: 'Venda T.',
        dataKey: 'qtdVendaTotal',
        sum: sum,
        descricao: 'Soma das vendas futuras já efetivadas', //Venda Total
    },
    {
        width: 60,
        label: 'Prev.\n(-)',
        dataKey: 'qtdPrevisao',
        sum: sum,
        cell: (value, editavel, onChange, onKeyPress, onBlur, onPaste, onAuxClick) => {
            if (editavel === true) {
                return (
                    <Input
                        pattern='[0-9]*'
                        onChange={onChange}
                        onKeyPress={onKeyPress}
                        onBlur={onBlur}
                        onPaste={onPaste}
                        type='text'
                        placeholder=''
                        value={value ? value : ''}
                        className='col-sm-12 form-control-sm'
                        autoComplete='off'
                        onAuxClick={onAuxClick}
                    />
                );
            } else {
                return value ? value : '';
            }
        },
        descricao: 'Previsão de venda para cada PV enviada pelo comercial', //Previsao
    },
    {
        width: 60,
        label: 'Prev. T.\n(-)',
        dataKey: 'qtdPrevisaoTotal',
        descricao: 'Soma da previsão de todas as PVS', //Previsao total
    },
    {
        width: 75,
        label: 'RA-2ª Qual\n(-)',
        dataKey: 'qtdSegundaQualidade',
        sum: sum,
        descricao: 'Peças que sofreram algum tipo de problema no processo', //RA – 2º Qualidade (-)
    },
    {
        width: 60,
        label: 'Guardar\n(-)',
        dataKey: 'guardar',
        sum: sum,
        cell: (value, editavel, onChange, onKeyPress, onBlur, onPaste, onAuxClick) => {
            if (editavel === true) {
                return (
                    <Input
                        pattern='[0-9]*'
                        onChange={onChange}
                        onKeyPress={onKeyPress}
                        onBlur={onBlur}
                        onPaste={onPaste}
                        type='text'
                        placeholder=''
                        value={value ? value : ''}
                        className='col-sm-12 form-control-sm'
                        autoComplete='off'
                        onAuxClick={onAuxClick}
                    ></Input>
                );
            } else {
                return value ? value : '';
            }
        },
        descricao:
            'Estoque de segurança pré-definido, são valores fixos de acordo com a marca do material. Para consulta da regra acessar ZPP009 e ZPP008', //Guardar (-)
    },
    {
        width: 60,
        label: 'Múltiplo\n(-)',
        dataKey: 'multiplo',
        cell: (value, editavel, onChange, onKeyPress, onBlur, onPaste, onAuxClick) => {
            if (editavel === true) {
                return (
                    <Input
                        pattern='[0-9]*'
                        onChange={onChange}
                        onKeyPress={onKeyPress}
                        onBlur={onBlur}
                        onPaste={onPaste}
                        type='text'
                        placeholder=''
                        value={value ? value : ''}
                        className='col-sm-12 form-control-sm'
                        autoComplete='off'
                        onAuxClick={onAuxClick}
                    ></Input>
                );
            } else {
                return value ? value : '';
            }
        },
        descricao:
            'Múltiplo pré-definido para todos os materiais. O cadastro é um parâmetro do Eddie, para alterar deverá ser solicitado ao TI', //Múltiplo (-)
    },
    {
        width: 93,
        label: 'Sobra Guardar',
        dataKey: 'guardarCalculado',
        sum: sum,
        descricao: 'Mostra quanto foi programado para atender o guardar', //Sobra Guardar
    },
    {
        width: 80,
        label: 'Nec.',
        dataKey: 'necessidadeCalculada',
        sum: sum,
        descricao: '= (Estoque inicial + WIP) – (Estoque de segurança + Guardar + Previsão atual ou venda realizada)', //Necessidade
    },
    {
        width: 80,
        label: 'Nec.Mul.',
        dataKey: 'necessidadeMultiplo',
        sum: sum,
        descricao: 'Recalculado a necessidade de acordo com o múltiplo', // nec com Multiplo
    },
    {
        width: 80,
        label: 'Nec.Ant.',
        dataKey: 'qtdNecAntecipada',
        descricao: '= (% de antecipação) * (venda total ou previsão total) - (Saldo cobertura)', // Nec Ant
    },
    {
        width: 70,
        label: 'Saldo Qtd. Ant.',
        dataKey: 'saldoQtdAnt',
        descricao: 'Saldo descontado a Nec. Ant. do WIP Futuro', // Saldo Qnt. Ant.
    },
    {
        width: 61,
        label: 'Est. Final\n(=)',
        dataKey: 'estoqueFinal',
        sum: sum,
        descricao: '= (Estoque inicial + WIP + Guardar + Quantidade de peças) - (Guardar + Previsão atual ou venda realizada)', //Estoque Final
    },
    {
        width: 70,
        label: 'Licença',
        dataKey: 'licenca',
        descricao: 'Licença de produto', // Licença
    },
    {
        width: 80,
        label: 'Cliente',
        dataKey: 'cliente',
        descricao: 'ID do Cliente', // Cliente
    },
    {
        width: 80,
        label: 'Cliente especial',
        dataKey: 'clienteEspecial',
        descricao: 'Cliente especial', // Cliente especial
    },
    {
        width: 70,
        label: 'G. Produto',
        dataKey: 'grupoDeProduto',
        descricao: 'Grupo de produtos', // Grupo de produtos
    },
    {
        width: 70,
        label: 'Est.Final\nFechamento',
        dataKey: 'estoqueFinalFechamento',
        sum: sum,
        descricao: 'Busca o estoque final do dia do fechamento (versão salva no BI) para analises de reposição.', //Estoque Final fechamento
    },
    {
        width: 84,
        label: 'Saldo Cober.\n(=)',
        dataKey: 'saldoCobertura',
        sum: sum,
        descricao:
            '= (Estoque inicial + WIP + Guardar + Quantidade de peças) - (Guardar + Estoque de segurança + Previsão atual ou venda realizada)', //Saldo cobertura
    },
    {
        width: 84,
        label: 'Gastar',
        dataKey: 'qtdGastar',
        sum: sum,
        descricao: 'Gastar', //Gastar
    },
    {
        width: 76,
        label: 'Cob.Est.(%)\n(=)',
        dataKey: 'coberturaEstoque',
        copy: (line) => line.coberturaEstoque.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
        cell: (value) => ({ value }),
        percCoberturaEstoque: percCoberturaEstoqueCalc,
        sum: sum,
        descricao: '= (Saldo cobertura ÷ Previsão total)', //Cobertura Estoque %
    },
    {
        width: 60,
        label: 'Tempo',
        dataKey: 'tempo',
        cell: (value) => ({ value }),
        descricao: 'Tempo unitário do processo de costura', //Tempo Costura
    },
    {
        width: 79,
        label: 'Tempo Total',
        dataKey: 'totalMinutos',
        sum: sum,
        copy: (line) => line.totalMinutos.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
        descricao: '= (Tempo unitário da peça X Quantidade de peças programadas)', //Tempo Total Costura
    },
    {
        width: 79,
        label: 'Tempo T.Prep.',
        sum: sum,
        dataKey: 'tempoTotalPreparacao',
        copy: (line) => line.tempoTotalPreparacao.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
        descricao: '= (Tempo unitário da peça X Quantidade de peças programadas)', //Tempo total Prep.
    },
    {
        width: 65,
        label: 'Fáb. Prep',
        dataKey: 'cdFabricaPrep',
        descricao: 'Fábrica onde a preparação pode ser produzida de acordo com a escolha da fábrica de costura. ', //Fábrica de preparação
    },
    {
        width: 60,
        label: 'Nivel Risco',
        dataKey: 'nivelRisco',
        descricao: 'Informa o nivel de risco cadastrado nas configurações', //Nivel Risco
    },
    {
        width: 200,
        label: 'Observação',
        dataKey: 'observacao',
        descricao: 'Dados cadastrados na aba classificação da MM03, ex.: Cotas', //Observação
    },
];
